import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./coming-soon.css";

const ComingSoonPage = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    const html = document.documentElement;
    const body = document.body;
    const prev = {
      htmlOverflow: html.style.overflow,
      bodyOverflow: body.style.overflow,
      bodyHeight: body.style.height,
      htmlOverscroll: html.style.overscrollBehavior,
      bodyOverscroll: body.style.overscrollBehavior,
    };
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.height = "100%";
    html.style.overscrollBehavior = "none";
    body.style.overscrollBehavior = "none";
    html.classList.add("agc-cs-lock");
    body.classList.add("agc-cs-lock");
    return () => {
      html.style.overflow = prev.htmlOverflow;
      body.style.overflow = prev.bodyOverflow;
      body.style.height = prev.bodyHeight;
      html.style.overscrollBehavior = prev.htmlOverscroll;
      body.style.overscrollBehavior = prev.bodyOverscroll;
      html.classList.remove("agc-cs-lock");
      body.classList.remove("agc-cs-lock");
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Coming Soon | ARAB Global Exchange</title>
        <meta
          name="description"
          content="This ARAB Global Exchange experience is under construction. Check back soon."
        />
      </Helmet>

      <main className="agc-cs" aria-labelledby="agc-cs-title">
        <div className="agc-cs__ambient" aria-hidden="true">
          <span className="agc-cs__blob agc-cs__blob--1" />
          <span className="agc-cs__blob agc-cs__blob--2" />
          <span className="agc-cs__blob agc-cs__blob--3" />
          <span className="agc-cs__grid" />
        </div>

        <div className="agc-cs__shell">
          <div className="agc-cs__card">
            <div className="agc-cs__shine" aria-hidden="true" />

            <Link to="/" className="agc-cs__logo-link" aria-label="ARAB Global Exchange home">
              <img
                className="agc-cs__logo"
                src="/images/logo_light.svg"
                alt="ARAB Global Exchange"
                width={500}
                height={137}
                fetchPriority="high"
                decoding="async"
              />
            </Link>

            <h1 id="agc-cs-title" className="agc-cs__title">
              Coming <span>Soon</span>
            </h1>

            <p className="agc-cs__text">
              We&apos;re crafting something powerful for ARAB Global.
              Check back soon — markets and trading are ready now.
            </p>

            <div className="agc-cs__loader" aria-hidden="true">
              <span className="agc-cs__loader-bar" />
            </div>

            <div className="agc-cs__btns">
              <Link to="/" className="agc-cs__btn agc-cs__btn--main">
                <i className="ri-home-5-line" aria-hidden="true" />
                Back to Home
              </Link>
              <Link to="/market" className="agc-cs__btn agc-cs__btn--soft">
                <i className="ri-line-chart-line" aria-hidden="true" />
                Browse Markets
              </Link>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ComingSoonPage;
